<template>
  <el-dialog title="售后商品信息" :visible.sync="visibleDialog" width="1100px" top="calc(50vh - 220px)" class="pop-dialog pop-goods-info" append-to-body>
    <div class="goods-con" v-loading="loading">
      <el-table :data="tableData" height="300px">
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="goods-info">
              <div class="img">
                <el-image :src="scope.row.goodsSkuPic" class="pic" fit="cover">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div class="con">
                <div class="name">{{ scope.row.goodsName }}</div>
                <div class="text">{{ scope.row.goodsSkuName }}</div>
                <div class="text">体积：{{ scope.row.goodsVolume}}<span class="space"></span>重量：{{ scope.row.goodsWeight}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="编号" width="180">
          <template slot-scope="scope">
            <div class="name">商品编号：{{ scope.row.goodsSku || '缺失' }}</div>
            <div class="text">外部编号：{{ scope.row.wuyuSku || '缺失' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="售后类型" width="80">
          <template slot-scope="scope">
            <div class="name">{{scope.row.afterSalesTypeName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="售后件登记" width="90">
          <template slot-scope="scope">
            <div class="name">完好：{{ scope.row.intactQuantity }}</div>
            <div class="name">破损：{{ scope.row.damagedQuantity }}</div>
            <div class="name">漏件：{{ scope.row.missingPartsQuantity }}</div>
          </template>
        </el-table-column>
        <el-table-column label="是否理赔" width="80">
          <template slot-scope="scope">
            <!-- 是否理赔：0-否，1-是 -->
            <div class="name">{{ scope.row.isClaim?'是':'否' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="快速理赔金额" width="95">
          <template slot-scope="scope">
            <div class="name">￥{{ scope.row.claimAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="售后件备注" width="90">
          <template slot-scope="scope">
            <div class="name">{{ scope.row.itemRemark }}</div>
          </template>
        </el-table-column>
        <el-table-column label="售后件阶段" width="85">
          <template slot-scope="scope">
            <div class="name">{{ scope.row.subsetStatusName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="发起退换时间" width="94">
          <template slot-scope="scope">
            <div class="name">{{ scope.row.applyTimeDay }}</div>
            <div class="name">{{ scope.row.applyTimeTime }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'popGoodsInfo',
  data() {
    return {
      visibleDialog: false, // 商品信息
      tableData: [],
      loading: false,
      type: '',
      orderNo:''
    }
  },
  methods: {
    // 批量设置不需要回显
    show(data) {
      this.type = data.type || ''
      this.orderNo = data.orderNo || 'A2507171818367345'
      this.tableData = data.list
      console.log('show:', data)
      if(this.orderNo){
        this.fetchData()
      }
      this.visibleDialog = true
    },
    fetchData() {
      this.loading = true
      this.$api.omsAfterSales(this.orderNo).then(res => {
        if (res.code == 0) { 
          this.tableData = res.data.map(item => {
            if (item.applyTime) {
              const [datePart, timePart] = item.applyTime.split(' ')
              return {
                ...item,
                applyTimeDay: datePart || '',
                applyTimeTime: timePart || ''
              }
            }
            return item
          })
        }
      }).finally(() => { 
        this.loading = false
      })
    },

  },
}
</script>
<style lang='scss'>
.pop-goods-info {
  .goods-con {
    padding: 10px 0 20px;
    
    .goods-info{
      display: flex;
      .img{
        padding-right: 12px;
      }
      .space{
        display: inline-block;
        width: 20px;
      }
      .space-top{
        padding-top: 4px;
      }
      
    }
    .hand{
      cursor: pointer;
    }
    .name{
      color: #333;
    }
    .text{
      color: #7F7F7F;
    }
    
    .el-table{
      // border: 1px solid #E3E3E3;
      // border-bottom: none;
       .el-table__body-wrapper{
        scrollbar-width: thin;
       }
    }
    .el-table th.el-table__cell {
      padding: 0;
      height: 28px;
      line-height: 28px;
      font-weight: normal;
      background-color: #F8F8F8;

      .cell {
        font-size: 12px;
        font-weight: normal;
        padding-left: 12px;
        color: #7F7F7F;
      }
    }

    .el-table td.el-table__cell {
      padding: 0;
      padding: 6px 0 8px;

      .cell {
        font-size: 12px;
        padding-left: 12px;
        line-height: 18px;
      }


    }
    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
      background: #E3F0FC;
    }
  }

  .total-con {
    height: 57px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .total-price {
      display: inline-block;
      width: 80px;
      text-align: left;
      box-sizing: border-box;
      padding-left: 12px;
    }
    .total-number{
      display: inline-block;
      width: 80px;
      text-align: left;
      box-sizing: border-box;
      padding-left: 12px;
    }
  }

}
// 编辑商品
.pop-goods-edit{ 
    .edit-con{
    padding-top: 20px;
  }
}
</style>